<template>
    <div 
        class="modal fade"
        id="showPazienteModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        {{paziente.cognome}} {{paziente.nome}}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body" align="left">
                    <p class="lead">
                        <strong>Data di nascita:</strong> {{paziente.data_nascita}}
                    </p>
                    <p class="lead">
                        <strong>Cellulare:</strong> {{paziente.cellulare}}
                    </p>
                    <p class="lead">
                        <strong>Email:</strong> {{paziente.email}}
                    </p>
                    <p class="lead">
                        <strong>Indirizzo:</strong> {{paziente.indirizzo}}
                    </p>
                    <p class="lead">
                        <strong>Città:</strong> {{paziente.citta}}
                    </p>
                    <p class="lead">
                        <strong>CAP:</strong> {{paziente.cap}}
                    </p>
                    
                </div>
                <div class="modal-footer">
                    
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        paziente: Object,
        isShow: Boolean
    },
    data() {
        return {
            modal: null,
            
        };
    },
    mounted() {
        var modalEl = document.getElementById('showPazienteModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelShowChanged',false)
        })
    },
    methods: {
        close(){
            this.isShow = false
        },
        
    },
};
</script>
